import { GrowthBook } from '@growthbook/growthbook';
import mixpanel from 'mixpanel-browser';

export default defineNuxtPlugin(async (nuxtApp) => {

  if (import.meta.env.SSR) return;

  const config = useRuntimeConfig();
  const mixPanelToken = config.public.mixpanel_token;

  const isDev = import.meta.env.DEV;
  const URL = isDev ? 'http://localhost:3000' : ''

  const growthbook = new GrowthBook({
    apiHost: 'https://cdn.growthbook.io',
    clientKey: config.public.growthbook_client_key,
    enableDevMode: false,
    subscribeToChanges: true,
    debug: false,
    attributes: {
      url: window.location.href,
    },
    trackingCallback: (experiment, result) => {
      mixpanel.track("$experiment_started", {
        "Experiment name": experiment?.key,
        "Variant name": result?.variationId,
        $source: 'growthbook'
      })

    },
  })
  mixpanel.init(mixPanelToken, {
    api_host: `${URL}/api/tracking`,
    persistence: 'localStorage',
    geolocate: true,
    ip: false,
    batch_requests: false,
    record_sessions_percent: 1,
    stop_utm_persistence: true,
    debug: false,
    autocapture: {
      pageview: false,
      click: false,
      input: false,
      scroll: false,
      submit: false,
    },
    loaded: function (mx) {
      growthbook.setAttributes({
        ...growthbook.getAttributes(),
        id: mixpanel.get_distinct_id()
      })
    }
  })

  // Wait for features to be available
  await growthbook.loadFeatures();

  return {
    provide: {
      growthbook,
    }
  };
});
